/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Form, Button, Spinner } from 'react-bootstrap';
import { connect } from 'react-redux';
import Axios from 'axios';
import { Redirect } from 'react-router-dom';

// project imports
import { getSellerUrl, getSellerHeaders } from 'shared/http';
import { LocationDefaults, LocationValidators } from 'features/classes';
import { ArrayValueReorder, commonMobileNumberFormat } from 'shared/modifiers';
import {
    citylist, locationdetail, locationupdate, sellerdetail, stateCityCheck, statecitybyzipcode,
    statelist, timezonelist
} from 'shared/settings/apiconfig';
import Validators from 'shared/validators';
// import toast from 'shared/toast';
import { ToasterMessage } from 'shared/toast/toast';
import { BUYER_URL } from 'shared/settings/config';
import {DebounceInput} from 'react-debounce-input';

// style imports
import './LocationEdit.scss';
import { NoData } from 'features/components/redirect/NoData';

/**
 * this page is used to edit location details by only administrator
 * 
 * @param locationId
 * 
 * @param props
 * 
 * @returns html code for editing location details
 * 
**/

class LocationEdit extends Component {

    locationData;
    userRole;
    timeZoneList;
    stateList;

    constructor(props) {
        super(props);

        this.state = {
            // page editable or not
            viewOnly: false,

            errorpageredirect: false,
            formValid: false,
            formControls: {},
            city: [],

            // loading
            pageLoading: true,
            locationFormLoading: false,
            locationStatus: { show: false, type: '', message: '' },
            ispickup: '',
            isdelivery: '',
            isshipping: '',
            isautodebit: false,
            stateCityError: '',
            cityStateIsValid: true,
            cityDropdownValue: [],
            showCityDropdown: false,
            irmValid: false,
            chars_left: 100,
            shippingsaint: false,
            errorType: '',
            istestlocation: false,
        };

        this.locationData = new LocationDefaults();
        this.userRole = '';
        this.timeZoneList = [];
        this.stateList = [];
        this.approveBack = false;
        this.errorMessage = "The Zip code, State and City not matching please enter correct information";
    }

    componentDidMount() {
        this.getLocationData();
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
    }

    onBack = (e) => {
        e.preventDefault();
        if (this.approveBack) {
            window.removeEventListener('popstate', this.onBack);
        } else {
            this.approveBack = true;
            this.navigateToList();
        }
    }

    /* fetch location data for location id */
    getLocationData = async () => {
        // const field = ['id', 'role'];
        await Axios.all([
            Axios.get(getSellerUrl(`${locationdetail}/${this.props.match.params['locationId']}`), getSellerHeaders()),
            await Axios.get(getSellerUrl(timezonelist), getSellerHeaders()),
            await Axios.get(getSellerUrl(statelist), getSellerHeaders())
        ])
            .then((response) => {
                if (Object.keys(response[0].data?.data).length === 0 || response[0].data['data'].length == 0) {
                    this.setState({
                        errorpageredirect: true,
                        errorType: "noData"
                    })
                    return;
                } else {
                    this.locationData = new LocationDefaults(response[0].data['data'][0]);
                }

                // for (let role of response[1].data['data']) {
                //     if (role['role'] === 'Administrator') {
                //         this.setState({ viewOnly: false });
                //         break;
                //     }
                // }
                this.timeZoneList = ArrayValueReorder(response[1].data['data'], 'zonename');
                this.locationData.timezone = this.timeZoneList.find(el => el['zonename'] === this.locationData.timezone)['id'];

                this.stateList = ArrayValueReorder(response[2].data['data'], 'state');
                if (this.stateList.length === 1) {
                    this.setState({
                        formControls: {
                            state: {
                                ...this.state.formControls.state,
                                value: this.stateList[0]['state'],
                                error: '',
                                valid: true
                            },
                        }
                    }, () => {
                        /* checks the form is valid or not */
                        this.setState({ formValid: Validators.checkFormValid(this.state.formControls) });
                    })

                }

                this.setFormData();
                let locationreceipt = response[0].data['data'][0]['locationitemreceipt']
                this.setreceiptData(locationreceipt)
                if(this.state.isdelivery || this.state.ispickup || this.state.isshipping){
                    this.setState({
                        irmValid: false
                    })
                }
                else{
                    this.setState({
                        irmValid: true
                    })
                }
               
                this.checkStateAndCity(this.state.formControls.zip.value, this.state.formControls.state.value, this.state.formControls.city.value);
                this.setState({ pageLoading: false });
            })
            .catch((error) => {
                // toast.error(error.response.data['message']);
                if(error?.response?.status == 401 || error?.response?.status == 404) {
                    this.setState({
                        pageLoading: false,
                        errorpageredirect: true,
                        errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                    })
                }
            });
    };

    /* validates data and sets error and data validity */
    setFormData = () => {
        Object.entries(this.locationData).forEach(([key, value]) => {
            let error = '';

            // set error for the control
            for (let validator of LocationValidators[key]) {
                error = validator(value);
                if (error) {
                    break;
                }
            }

            // set state for the control
            this.setState({
                formControls: {
                    ...this.state.formControls,
                    [key]: {
                        value: value,
                        error: error,
                        valid: !Boolean(error),
                        validators: LocationValidators[key]
                    }
                }
            });
        });
        this.setState({
            isautodebit: this.locationData['isautodebit'],
            shippingsaint: this.locationData['shippingsaint'],
            // istestlocation: this.locationData['istestlocation']
        })
        this.getCity('zipcode', this.locationData['state'])

        /* checks the form is valid or not */
        this.setState({ formValid: Validators.checkFormValid(this.state.formControls) });
    };

    // edit location values retain methods
    setreceiptData(locationreceipt) {
        if (this.props.match.params['locationId']) {
            this.setState({
                ispickup: locationreceipt ? this.getBool(JSON.stringify(JSON.parse(locationreceipt)['pickup'])) : false,
                isshipping: locationreceipt ? this.getBool(JSON.stringify(JSON.parse(locationreceipt)['shipping'])) : false,
                isdelivery: locationreceipt ? this.getBool(JSON.stringify(JSON.parse(locationreceipt)['delivery'])) : false,
            })
        }
    }

    // get boolean values 
    getBool(val) {
        try {
            if (val)
                return !!JSON.parse(String(val).toLowerCase());
            else
                return false
        } catch (e) {
            return false
        }
    }

    //item receipt checkbox handling
    receiptCheckBox = (event) => {
        let eventValue = event.target.value;
        if (event.target.name === 'isshipping') {
            eventValue = Boolean(event.target.checked);
            this.setState({
                isshipping: eventValue
            })
        }
        if (event.target.name === 'ispickup') {
            eventValue = Boolean(event.target.checked);
            this.setState({
                ispickup: eventValue
            })
        }
        if (event.target.name === 'isdelivery') {
            eventValue = Boolean(event.target.checked);
            this.setState({
                isdelivery: eventValue
            })
        }
        setTimeout(()=> {
            if(this.state.isdelivery || this.state.ispickup || this.state.isshipping){
                this.setState({
                    irmValid: false
                })
            }
            else{
                this.setState({
                    irmValid: true
                })
            }
        })
       
    }

    /* sets city, state, country based on zip */
    autoFillAddress = async (zipCodeValue) => {
        await Axios.get(getSellerUrl(`${statecitybyzipcode}/${zipCodeValue}`), getSellerHeaders())
            .then(response => {
                if (response.data['data'].length) {
                    this.setState({
                        formControls: {
                            ...this.state.formControls,
                            // city: {
                            //     ...this.state.formControls.city,
                            //     value: response.data['data'][0]['city'],
                            //     error: '',
                            //     valid: true
                            // },
                            state: {
                                ...this.state.formControls.state,
                                value: response.data['data'][0]['state'],
                                error: '',
                                valid: true
                            },
                            country: {
                                ...this.state.formControls.country,
                                value: 'USA',
                                error: '',
                                valid: true
                            }
                        }
                    }, () => {
                        this.getCity('zipcode', this.state.formControls.state.value);
                        this.checkStateAndCity(this.state.formControls.zip.value, this.state.formControls.state.value, this.state.formControls.city.value);
                    });
                }
                else {
                    // toast.warn('Matching ZIP Code not found to autofill');
                    this.setState({
                        city: [],
                        formControls: {
                            ...this.state.formControls,
                            // city: {
                            //     ...this.state.formControls.city,
                            //     value: '',
                            //     error: '',
                            //     valid: false
                            // },
                            state: {
                                ...this.state.formControls.state,
                                value: '',
                                error: '',
                                valid: false
                            },
                            country: {
                                ...this.state.formControls.country,
                                value: 'USA',
                                error: '',
                                valid: true
                            }
                        },
                        locationStatus: { show: true, type: 'warn', message: 'Matching ZIP Code not found to autofill' }
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                locationStatus: { show: false, type: '', message: '' }
                            });
                        }, 3000);
                    });

                }

                /* checks the form is valid or not */
                this.formValidate()
            })
            .catch(error => {
                // toast.error(error.response.data['message']);
                this.setState({
                    locationStatus: { show: true, type: 'danger', message: error?.response?.data['message'] }
                });
            });
    };
    formValidate() {
        this.setState({ formValid: Validators.checkFormValid(this.state.formControls) });
    }
    /* get city list */
    getCity = (callFrom, stateValue) => {
        let cityList = [];
        if (stateValue) {
            Axios.get(getSellerUrl(`${citylist}/${stateValue}`), getSellerHeaders())
                .then(response => {
                    cityList = ArrayValueReorder(response.data.data, 'city');
                    cityList = cityList.filter((city, index) => {
                        const _city = JSON.stringify(city);
                        return index === cityList.findIndex(obj => {
                            return JSON.stringify(obj) === _city;
                        });
                    });

                    if ((this.edit || callFrom === 'state') && callFrom !== 'zipcode') {
                        this.setState({
                            city: cityList,
                            formControls: {
                                ...this.state.formControls,
                                city: {
                                    ...this.state.formControls.city,
                                    error: cityList.length === 1 ? '' : 'Please enter value',
                                    valid: cityList.length === 1 ? true : false,
                                    value: cityList.length === 1 ? cityList[0]['city'] : this.state.formControls.city.value
                                }
                            }
                        }, () => {
                            /* checks the form is valid or not */
                            this.setState({ formValid: Validators.checkFormValid(this.state.formControls) });
                        });
                    } else {
                        this.setState({
                            city: cityList
                        }, () => {
                            /* checks the form is valid or not */
                            this.setState({ formValid: Validators.checkFormValid(this.state.formControls) });
                        });
                    }

                })
                .catch(error => {
                    // toast.error(error.response.data['message']);
                    this.setState({
                        ...this.state,
                        formLoading: false,
                        locationStatus: { show: true, type: 'danger', message: error?.response?.data['message'] }
                    });
                });
        }
    };

    /* checks whether the input is valid or not */
    onInputValidation = async (event) => {
        if (event.target.name === 'sendinvoicecopy') {
            event.target.value = Boolean(event.target.checked);
        }
        if (event.target.name === 'autosku') {
            event.target.value = Boolean(event.target.checked);
        }
        if (event.target.name === 'applytaxonbp') {
            event.target.value = Boolean(event.target.checked);
        }
        // if (event.target.name === 'isshippable') {
        //     event.target.value = Boolean(event.target.checked);
        // }
        if(event.target.name === "status" && event.target.value == "Inactive"){
            this.setState({ 
                formControls: {
                    ...this.state.formControls,
                    locationstatusnote: {
                        ...this.state.formControls.locationstatusnote,
                        validators: event.target.value == "Inactive" ? [Validators.required()] : [],
                    }
                }
            })}
        if(event.target.name === 'franchisedetail'){
            event.target.value =  event.target.value.replace(/[^0-9,]/g, '');
        }
         if(event.target.name === 'franchiseid'){
            event.target.value =  event.target.value.replace(/[^0-9]/g, '');
            this.setState({ 
                formControls: {
                    ...this.state.formControls,
                    franchiseid: {
                        ...this.state.formControls.franchiseid,
                        validators:  [Validators.required()] 
                    }
                }
            })
        }
        else if (event.target.name === 'phone') {
            const mobileValue = commonMobileNumberFormat(event.target.value, this.state.formControls.phone.value);
            event.target.value = mobileValue ? mobileValue : event.target.value;
        }

        this.setState({
            ...Validators.formValidation({ ...this.state.formControls }, event)
        }, () => {
            if (event.target.name === 'sendinvoicecopy') {
                this.handleInvoiceccemail(event.target.value);
            }
            if (event.target.name === 'franchisedetail') {
                this.validFranchiseId(event.target.value);
            }
            let formError = this.state.locationStatus.message;
            if (this.state.formValid)
                formError = this.state.locationStatus.message === 'Cannot save: please add the required fields in red above' ? '' : this.state.locationStatus.message;
            this.setState({
                locationStatus: {
                    ...this.state.locationStatus,
                    message: formError
                }
            })
        });

        if (event.target.name === 'zip') {
            if (isNaN(Number(event.target.value))) {
                this.setState({
                    formControls: {
                        ...this.state.formControls,
                        zip: {
                            ...this.state.formControls.zip,
                            value: ""
                        }
                    }
                })
            }
            if (event.target.value.includes(" ")) {
                this.setState({
                    formControls: {
                        ...this.state.formControls,
                        zip: {
                            ...this.state.formControls.zip,
                            value: this.state.formControls.zip.value.replace(/\s/g, "")
                        }
                    }
                })
            }
            if (event.target.value.length === 5) {
                await this.autoFillAddress(event.target.value);
            }
        }

        if (event.target.name === 'state') {
            // this.getCity('state', event.target.value);
            this.checkStateAndCity(this.state.formControls.zip.value, event.target.value, this.state.formControls.city.value);

        }

        if (event.target.name === 'city') {
            this.checkStateAndCity(this.state.formControls.zip.value, this.state.formControls.state.value, event.target.value);
            if(this.state.cityDropdownValue.length > 0 && !this.state.showCityDropdown){
                this.setState({
                    showCityDropdown: true
                })
            }
        }
    };
    validFranchiseId = (value) => {
        let data = value.includes(',') ? true : false
        let franchisedetailValueSplit = value.split(',')
        this.setState({
            formControls: {
                ...this.state.formControls,
                franchiseid: {
                    ...this.state.formControls.franchiseid,
                    value: data ? this.state.formControls.franchiseid.value  :  franchisedetailValueSplit[0],
                    validators: data ? [Validators.required()] : []
                }
            }
        }, () => {
            const event = {
                target: {
                    name: 'franchiseid',
                    value: this.state.formControls.franchiseid.value 
                }
            }
            this.setState({
                ...Validators.formValidation({ ...this.state.formControls }, event)
            }, () => {
                let formError = this.state.locationStatus.message;
                if (this.state.formValid)
                    formError = this.state.locationStatus.message === 'Cannot save: please add the required fields in red above' ? '' : this.state.locationStatus.message;
                this.setState({
                    locationStatus: {
                        ...this.state.locationStatus,
                        message: formError
                    }
                })
            });
        });

    }

    /* called when save button clicked */4
    checkFieldValidation = (event) => {
        // stops child event trigger
        event.preventDefault();

        let valid = true;
        let stateData = this.state.formControls;
        for (let control of Object.keys(stateData)) {
            let inputError = '';
            for (let validator of stateData[control].validators) {
                inputError = validator(stateData[control].value);
                if (inputError) {
                    valid = false;
                    break;
                }
            }
            stateData[control]['error'] = inputError;
        }
        this.setState({
            ...this.state,
            formValid: valid,
            formControls: stateData,
            locationStatus: { show: !valid, type: !valid ? 'danger' : '', message: !valid ? 'Cannot save: please add the required fields in red above' : '' }
        }, () => {
            if (this.state.formValid)
                this.onSaveLocation(event);
        })
    }

    camelize = (str) => {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word) {
            return word.toUpperCase();
        }).replace(/\s+/g, ' ');
    }

    handleInvoiceccemail = (flag) => {
        this.setState({
            formControls: {
                ...this.state.formControls,
                invoiceccemail: {
                    ...this.state.formControls.invoiceccemail,
                    validators: JSON.parse(flag) ? [Validators.required(), Validators.email(), Validators.maxLength(45)] : []
                }
            }
        }, () => {
            const event = {
                target: {
                    name: 'invoiceccemail',
                    value: ''
                }
            }
            this.setState({
                ...Validators.formValidation({ ...this.state.formControls }, event)
            }, () => {
                let formError = this.state.locationStatus.message;
                if (this.state.formValid)
                    formError = this.state.locationStatus.message === 'Cannot save: please add the required fields in red above' ? '' : this.state.locationStatus.message;
                this.setState({
                    locationStatus: {
                        ...this.state.locationStatus,
                        message: formError
                    }
                })
            });
        });

    }

    /* save location details */
    onSaveLocation = async (event) => {
        // stops child event trigger
         const franchisedetail  = (this.state.formControls.franchisedetail.value).split(',')
        event.preventDefault();
        try {

            if (!this.state.viewOnly && this.state.formValid && !this.state.locationFormLoading) {
                const data = {
                    id: this.props.match.params['locationId']
                };

                this.setState({ locationFormLoading: true });
                Object.entries(this.state.formControls).forEach(([key, value]) =>
                    data[key] = value['value'] !== '' ? value['value'] : null
                );
                data['franchiseid'] = franchisedetail.length > 1 ?  this.state.formControls.franchiseid.value : franchisedetail[0]
                data['sendinvoicecopy'] = (this.state.formControls.sendinvoicecopy?.value.toString() === 'true' || this.state.formControls.sendinvoicecopy?.value === 1) ? 1 : 0;
                data['autosku'] = (data['autosku'] === 'true' || data['autosku'] === 1);
                data['applytaxonbp'] = (data['applytaxonbp'] === 'true' || data['applytaxonbp'] === 1);
                // data['isshippable'] = (data['isshippable'] === 'true' || data['isshippable'] === 1);
                data['city'] = this.camelize(data['city']);
                if (data['sendinvoicecopy'] === 0) {
                    delete data['invoiceccemail']
                }
                let locationreceipt = {
                    "pickup": Boolean(this.state.ispickup),
                    "shipping": Boolean(this.state.isshipping),
                    "delivery": Boolean(this.state.isdelivery)
                };
                data['locationitemreceipt'] = locationreceipt;
                data['isautodebit'] = this.state.isautodebit;
                data['shippingsaint'] = this.state.shippingsaint;
                // data['istestlocation'] = this.state.istestlocation
                await Axios.put(getSellerUrl(locationupdate), JSON.stringify({ data: data }), getSellerHeaders())
                    .then((response) => {
                        if (response.data.data.length) {
                            // toast.success('Successful');
                            this.setState({
                                locationFormLoading: false,
                                locationStatus: { show: true, type: 'success', message: 'Saved' }
                            }, () => {
                                setTimeout(() => {
                                    this.setState({
                                        locationStatus: { show: false, type: '', message: '' }
                                    });
                                    // this.props.history.push({ pathname: '/locations', state: this.props.location.state });
                                }, 3000);
                            }
                            );

                        }
                    })
                    .catch((error) => {
                        this.setState({
                            locationFormLoading: false,
                            locationStatus: { show: true, type: 'danger', message: error?.response?.data['message'] }
                        });
                        // toast.error(error.response.data['message']);
                    });
            }
        } catch (e) {
            console?.clear()
        }
    };

    navigateToList = () => {
        this.props.history.push({ pathname: '/locations', state: this.props.location.state });
    };

    changeCommercePayment = (event) => {
        this.setState({
            "isautodebit": event.target.checked
        })
    };
      changeTestLocation = (event) => {
        this.setState({
            "istestlocation": event.target.checked,
        })
    };

    changeShippingSaint = (event) => {
            const isChecked = event.target.checked;
            this.setState({
                shippingsaint: isChecked,
                formControls: {
                    ...this.state.formControls,
                    shippingsaintaccountnumber: {
                        ...this.state.formControls.shippingsaintaccountnumber,
                        validators: isChecked ? [Validators.required()] : []
                    }
                }
            }, () => {
                const eventData = {
                    target: {
                        name: 'shippingsaintaccountnumber',
                        value: this.state.formControls.shippingsaintaccountnumber.value
                    }
                };
                this.setState({
                    ...Validators.formValidation(
                        { ...this.state.formControls },
                        eventData
                    )
                });
            });
        };
    
    checkStateAndCity = (zipcode, state, city) => {
        this.setState({
            cityStateIsValid: false
        })
        if (state != "" && city != "" && zipcode != "") {
            Axios.post(getSellerUrl(`${stateCityCheck}`), { data: { "zipcode": zipcode, "state": state, "city": city } }, getSellerHeaders()).then(response => {
                this.setState({
                    stateCityError: "",
                    cityStateIsValid: true,
                    showCityDropdown: false
                })
            }).catch(error => {
                if (error.response.data.status === 400 || error.response.data.status == "failed") {
                    this.setState({
                        stateCityError: this.errorMessage,
                        cityStateIsValid: false,
                        cityDropdownValue: error.response.data.error.data,
                    })
                }
            });
        }
    }

    setCityValue = (city) => {
        this.setState({
            formControls: {
                ...this.state.formControls,
                city: {
                    ...this.state.formControls.city,
                    value: city,
                    error: '',
                    valid: true
                }
            },
            showCityDropdown: false
        }, () => this.checkStateAndCity(this.state.formControls.zip.value, this.state.formControls.state.value, this.state.formControls.city.value))
    }

    render() {
        if (this.state.errorpageredirect) {
            // redirect to Not-Found if wrong Locationid
            return <NoData {...this.props} type={this.state.errorType} />
        }
        return (
            <div className="d-flex flex-column location-edit-content">
                <div className="d-flex flex-row align-items-center border-bottom border-outline" style={{ minHeight: '40px' }}>
                    <div className="d-flex flex-row align-items-center justify-content-center border-right border-outline px-2 h-100">
                        <span onClick={this.navigateToList} className="clickable">
                            <i className="fa fa-chevron-circle-left fa-lg text-back rounded-circle"></i>
                            <span className="ml-2">Back</span>
                        </span>
                    </div>
                    <span className="text-secondary mx-2">{this.locationData['title']}</span>
                </div>
                {
                    this.state.pageLoading ?
                        <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                        </div> :
                        <Form className="border p-2" style={{ margin: "1rem 4%" }} onSubmit={this.checkFieldValidation} >
                            <div className="d-flex flex-column align-items-center justify-content-center" >
                                <div className="d-flex flex-column flex-sm-row" style={{ width: '90%', marginBottom: '70px' }}>

                                    {/* first section contains location details */}
                                    <div className="d-flex flex-column flex-fill mx-lg-5">
                                        <span className="text-secondary">Location Details</span>
                                        <div className="d-flex flex-column form-width" style={{ width: '85%' }}>

                                            <div className="float-control">
                                                <div className="text">
                                                    {
                                                        this.state.formControls.franchisedetail.error ? <small className="error">{this.state.formControls.franchisedetail.error}</small> : null
                                                    }
                                                </div>
                                                <Form.Control type="text" id="franchisedetail" className={`${this.state.formControls.franchisedetail.error ? 'error-control' : ''} ${this.state.formControls.franchisedetail.value ? 'form-control-active' : ''}`} name="franchisedetail" value={this.state.formControls.franchisedetail.value} disabled={this.state.viewOnly} placeholder=" " onChange={(event) => this.onInputValidation(event)} />
                                                <label htmlFor="franchisedetail">Franchise ID # *</label>
                                            </div>

                                            { this.state.formControls.franchisedetail.value.includes(',') ?
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.formControls.franchiseid.error ? <small className="error">{this.state.formControls.franchiseid.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control type="text" id="franchiseid" className={`${this.state.formControls.franchiseid.error ? 'error-control' : ''} ${this.state.formControls.franchiseid.value ? 'form-control-active' : ''}`} name="franchiseid" value={this.state.formControls.franchiseid.value} disabled={this.state.viewOnly} placeholder=" " onChange={(event) => this.onInputValidation(event)} />
                                                    <label htmlFor="franchiseid">Franchise Master ID *</label>

                                                </div> : ''
                                            }

                                            <div className="float-control">
                                                <div className="text">
                                                    {
                                                        this.state.formControls.title.error ? <small className="error">{this.state.formControls.title.error}</small> : null
                                                    }
                                                </div>
                                                <Form.Control type="text" id="location-title" className={`${this.state.formControls.title.error ? 'error-control' : ''} ${this.state.formControls.title.value ? 'form-control-active' : ''}`} name="title" value={this.state.formControls.title.value} disabled={this.state.viewOnly} placeholder=" " onChange={(event) => this.onInputValidation(event)} />
                                                <label htmlFor="location-title">Location Title *</label>
                                            </div>

                                            <div className="float-control">
                                                <div className="text">
                                                    {
                                                        this.state.formControls.description.error ? <small className="error">{this.state.formControls.description.error}</small> : null
                                                    }
                                                </div>
                                                <Form.Control type="text" id="brief-description" className={`${this.state.formControls.description.error ? 'error-control' : ''} ${this.state.formControls.description.value ? 'form-control-active' : ''}`} name="description" value={this.state.formControls.description.value} disabled={this.state.viewOnly} placeholder=" " onChange={(event) => this.onInputValidation(event)} />
                                                <label htmlFor="brief-description">Brief Description *</label>
                                            </div>

                                            <div className="float-control">
                                                <div className="text">
                                                    {
                                                        this.state.formControls.contactname.error ? <small className="error">{this.state.formControls.contactname.error}</small> : null
                                                    }
                                                </div>
                                                <Form.Control type="text" id="contact-name" className={`${this.state.formControls.contactname.error ? 'error-control' : ''} ${this.state.formControls.contactname.value ? 'form-control-active' : ''}`} name="contactname" value={this.state.formControls.contactname.value} disabled={this.state.viewOnly} placeholder=" " onChange={(event) => this.onInputValidation(event)} />
                                                <label htmlFor="contact-name">Contact Name *</label>
                                            </div>

                                            <div className="float-control">
                                                <div className="text">
                                                    {
                                                        this.state.formControls.email.error ? <small className="error">{this.state.formControls.email.error}</small> : null
                                                    }
                                                </div>
                                                <Form.Control type="text" id="location-email" className={`${this.state.formControls.email.error ? 'error-control' : ''} ${this.state.formControls.email.value ? 'form-control-active' : ''}`} name="email" value={this.state.formControls.email.value} disabled={this.state.viewOnly} placeholder=" " onChange={(event) => this.onInputValidation(event)} />
                                                <label htmlFor="location-email">Location Email *</label>
                                            </div>

                                            <div className="float-control">
                                                <div className="text">
                                                    {
                                                        this.state.formControls.phone.error ? <small className="error">{this.state.formControls.phone.error}</small> : null
                                                    }
                                                </div>
                                                <Form.Control type="text" id="location-phone" className={`${this.state.formControls.phone.error ? 'error-control' : ''} ${this.state.formControls.phone.value ? 'form-control-active' : ''}`} name="phone" value={this.state.formControls.phone.value} disabled={this.state.viewOnly} placeholder=" " onChange={(event) => this.onInputValidation(event)} />
                                                <label htmlFor="location-phone">Location Phone *</label>
                                            </div>

                                            <div className="float-control">
                                                <div className="text">
                                                    {
                                                        this.state.formControls.website.error ? <small className="error">{this.state.formControls.website.error}</small> : null
                                                    }
                                                </div>
                                                <Form.Control type="text" id="external-website" className={`${this.state.formControls.website.error ? 'error-control' : ''} ${this.state.formControls.website.value ? 'form-control-active' : ''}`} name="website" value={this.state.formControls.website.value} disabled={this.state.viewOnly} placeholder=" " onChange={(event) => this.onInputValidation(event)} />
                                                <label htmlFor="external-website">External Website *</label>
                                            </div>

                                            <div className="float-control">
                                                <div className="text">
                                                    {
                                                        this.state.formControls.country.error ? <small className="error">{this.state.formControls.country.error}</small> : null
                                                    }
                                                </div>
                                                <Form.Control as="select" className={`${this.state.formControls.country.value ? 'form-control-active' : 'text-muted'} ${this.state.formControls.country.error ? 'error-control' : ''}`} id="country" name="country" value={this.state.formControls.country.value} disabled={this.state.viewOnly} placeholder=" " onChange={(event) => this.onInputValidation(event)} >
                                                    <option style={{ display: "none" }} selected>Select Country</option>
                                                    <option value="USA">USA</option>
                                                </Form.Control>
                                                <label htmlFor="country">Country *</label>
                                            </div>

                                            <div className="float-control">
                                                <div className="text">
                                                    {
                                                        this.state.formControls.state.error ? <small className="error">{this.state.formControls.state.error}</small> : null
                                                    }
                                                </div>
                                                <Form.Control as="select" className={`${this.state.formControls.state.value ? 'form-control-active' : 'text-muted'} ${this.state.formControls.state.error ? 'error-control' : ''}`} id="state" name="state" value={this.state.formControls.state.value} disabled={this.state.viewOnly} placeholder=" " onChange={(event) => this.onInputValidation(event)} >
                                                    <option style={{ display: "none" }} selected>Select State</option>
                                                    {
                                                        this.stateList.map((state, idx) => <option key={idx} value={state['state']}>{state['state']}</option>)
                                                    }
                                                </Form.Control>
                                                <label htmlFor="state">State *</label>
                                            </div>

                                            <div className="float-control" style={{ paddingBottom: `${this.state.showCityDropdown ? '2px' : '' }`}}>
                                                {/* <div className="text">
                                                    {
                                                        this.state.formControls.city.error ? <small className="error">{this.state.formControls.city.error}</small> : null
                                                    }
                                                </div> */}
                                                {/* <Form.Control as="select" className={`${this.state.formControls.city.value ? 'form-control-active' : 'text-muted'} ${this.state.formControls.city.error ? 'error-control' : ''}`} id="city" name="city" value={this.state.formControls.city.value} disabled={this.state.viewOnly} placeholder=" " style={{ textTransform: "capitalize" }} onChange={(event) => this.onInputValidation(event)} >
                                                    <option style={{ display: "none" }} selected>Select City</option>
                                                    {
                                                        this.state.city.map((city, idx) => <option key={idx} value={city['city']}>{city['city']}</option>)
                                                    }
                                                </Form.Control> */}
                                                <DebounceInput type="text" className={`form-control ${this.state.formControls.city.value ? 'form-control-active' : 'text-muted'} ${this.state.formControls.city.error ? 'error-control' : ''}`} id="city" name="city" value={this.state.formControls.city.value} disabled={this.state.viewOnly} placeholder=" " style={{ textTransform: "capitalize" }} onChange={(event) => this.onInputValidation(event)} debounceTimeout={200} />
                                                <label htmlFor="city">City *</label>
                                            </div>
                                            {this.state.showCityDropdown ? <div className='location-city-value'>
                                                {this.state.cityDropdownValue.map((elem, index) => (
                                                    <div className='pd-15' id={index} onClick={() => { this.setCityValue(elem.city) }}>{elem.city}</div>
                                                ))}
                                            </div> : ""}
                                            <div className="float-control">
                                                <div className="text">
                                                    {
                                                        this.state.formControls.zip.error ? <small className="error">{this.state.formControls.zip.error}</small> : null
                                                    }
                                                </div>
                                                <Form.Control type="text" id="zip" maxLength={5} className={`${this.state.formControls.zip.error ? 'error-control' : ''} ${this.state.formControls.zip.value ? 'form-control-active' : ''}`} name="zip" value={this.state.formControls.zip.value} disabled={this.state.viewOnly} placeholder=" " onChange={(event) => this.onInputValidation(event)} />
                                                <label htmlFor="zip">ZIP *</label>
                                            </div>

                                            <div className="float-control">
                                                <div className="text">
                                                    {
                                                        this.state.formControls.about.error ? <small className="error">{this.state.formControls.about.error}</small> : null
                                                    }
                                                </div>
                                                <Form.Control as="textarea" row="3" id="about" className={`${this.state.formControls.about.error ? 'error-control' : ''} ${this.state.formControls.about.value ? 'form-control-active' : ''}`} name="about" value={this.state.formControls.about.value} disabled={this.state.viewOnly} placeholder=" " onChange={(event) => this.onInputValidation(event)} />
                                                <label htmlFor="about">About *</label>
                                            </div>

                                            <div className="float-control">
                                                <div className="text">
                                                    {
                                                        this.state.formControls.auctioneerlicense.error ? <small className="error">{this.state.formControls.auctioneerlicense.error}</small> : null
                                                    }
                                                </div>
                                                <Form.Control type="text" id="auctioneerlicense" maxLength={100} className={`${this.state.formControls.auctioneerlicense.error ? 'error-control' : ''} ${this.state.formControls.auctioneerlicense.value ? 'form-control-active' : ''}`} name="auctioneerlicense" value={this.state.formControls.auctioneerlicense.value} placeholder=" " onChange={(event) => this.onInputValidation(event)} />
                                                <label htmlFor="auctioneerlicense">Auctioneer License</label>
                                                <span className="align-self-end ml-auto" style={{ color: '#878787', marginBottom: '-7px' }}>{this.state.chars_left - this.state.formControls.auctioneerlicense.value.length}/100</span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* second section contains settigns and defaults */}
                                    <div className="d-flex flex-column flex-fill mx-lg-5">
                                        <span className="text-secondary">Settings & Defaults</span>
                                        <div className="d-flex flex-column form-width" style={{ width: '85%' }}>
                                            <div className="float-control">
                                                <div className="text">
                                                    {
                                                        this.state.formControls.timezone.error ? <small className="error">{this.state.formControls.timezone.error}</small> : null
                                                    }
                                                </div>
                                                <Form.Control as="select" type="text" id="time-zone" className={`${this.state.formControls.timezone.error ? 'error-control' : ''} ${this.state.formControls.timezone.value ? 'form-control-active' : ''}`} name="timezone" defaultValue={this.state.formControls.timezone.value} disabled={this.state.viewOnly} placeholder=" " onChange={(event) => this.onInputValidation(event)} >
                                                    <option style={{ display: "none" }} selected>Select Time Zone</option>
                                                    {
                                                        this.timeZoneList.map((el, idx) => <option key={idx} value={el['id']}>{el['displayname']}</option>)
                                                    }
                                                </Form.Control>
                                                <label htmlFor="time-zone">Time Zone *</label>
                                            </div>

                                            <div className="float-control">
                                                <div className="text">
                                                    {
                                                        this.state.formControls.paypalemail.error ? <small className="error">{this.state.formControls.paypalemail.error}</small> : null
                                                    }
                                                </div>
                                                <Form.Control type="email" id="paypal-email" className={`${this.state.formControls.paypalemail.error ? 'error-control' : ''} ${this.state.formControls.paypalemail.value ? 'form-control-active' : ''}`} name="paypalemail" value={this.state.formControls.paypalemail.value} disabled={this.state.viewOnly} placeholder=" " onChange={(event) => this.onInputValidation(event)} />
                                                <label htmlFor="paypal-email">PayPal Email *</label>
                                            </div>

                                            <div className="float-control">
                                                <div className="text">
                                                    {
                                                        this.state.formControls.googlecode.error ? <small className="error">{this.state.formControls.googlecode.error}</small> : null
                                                    }
                                                </div>
                                                <Form.Control type="text" id="google-code" className={`${this.state.formControls.googlecode.error ? 'error-control' : ''} ${this.state.formControls.googlecode.value ? 'form-control-active' : ''}`} name="googlecode" value={this.state.formControls.googlecode.value} disabled={this.state.viewOnly} placeholder=" " onChange={(event) => this.onInputValidation(event)} />
                                                <label htmlFor="google-code">Google Code</label>
                                            </div>

                                            <div className="float-control">
                                                <div className="text">
                                                    {
                                                        this.state.formControls.fbpixel.error ? <small className="error">{this.state.formControls.fbpixel.error}</small> : null
                                                    }
                                                </div>
                                                <Form.Control type="text" id="fb-pixel" className={`${this.state.formControls.fbpixel.error ? 'error-control' : ''} ${this.state.formControls.fbpixel.value ? 'form-control-active' : ''}`} name="fbpixel" value={this.state.formControls.fbpixel.value} disabled={this.state.viewOnly} placeholder=" " onChange={(event) => this.onInputValidation(event)} />
                                                <label htmlFor="fb-pixel">FB Pixel</label>
                                            </div>

                                            <div className="d-flex flex-column">
                                                <small className="text-muted">SKU Processing</small>
                                                <Form.Check type="checkbox" id="autosku" className={`${this.state.formControls.autosku.error ? 'error-control' : ''}`} name="autosku" label="Use Automatic SKU's" checked={this.state.formControls.autosku.value.toString() === 'true' || this.state.formControls.autosku.value === 1} disabled={this.state.viewOnly} onChange={(event) => this.onInputValidation(event)} />
                                            </div>

                                            <div className="float-control">
                                                <div className="text">
                                                    {
                                                        this.state.formControls.status.error ? <small className="error">{this.state.formControls.status.error}</small> : null
                                                    }
                                                </div>
                                                <Form.Control as="select" type="text" id="status" className={`${this.state.formControls.status.error ? 'error-control' : ''} ${this.state.formControls.status.value ? 'form-control-active' : ''}`} name="status" defaultValue={this.state.formControls.status.value} disabled={this.state.viewOnly} placeholder=" " onChange={(event) => this.onInputValidation(event)} >
                                                    <option style={{ display: "none" }}>Select Status</option>
                                                    <option value={"Active"}>Active</option>
                                                    <option value={"Inactive"}>Inactive</option>
                                                </Form.Control>
                                                <label htmlFor="time-zone">Status *</label>
                                            </div>
                                            {this.state.formControls.status.value === "Inactive" ?
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.formControls.locationstatusnote.error ? <small className="error">{this.state.formControls.locationstatusnote.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control as="textarea" row="3" id="locationstatusnote" className={`${this.state.formControls.locationstatusnote.error ? 'error-control' : ''} ${this.state.formControls.locationstatusnote.value ? 'form-control-active' : ''}`} name="locationstatusnote" value={this.state.formControls.locationstatusnote.value} disabled={this.state.viewOnly} placeholder=" " onChange={(event) => this.onInputValidation(event)} />
                                                    <label htmlFor="locationstatusnote">Status Notes</label>
                                                </div> : null
                                            }
                                            <div className="d-flex flex-column">
                                                <Form.Check type="checkbox" id="applytaxonbp" className={`${this.state.formControls.applytaxonbp?.error ? 'error-control' : ''}`} name="applytaxonbp" label="Apply Tax On Buyers Premium" checked={this.state.formControls.applytaxonbp?.value.toString() === 'true' || this.state.formControls.applytaxonbp?.value === 1} disabled={this.state.viewOnly} onChange={(event) => this.onInputValidation(event)} />
                                            </div>
                                            {/* <div className="d-flex flex-column">
                                                <Form.Check type="checkbox" id="isshippable" className={`${this.state.formControls.isshippable?.error ? 'error-control' : ''}`} name="isshippable" label="Shippable Items" checked={this.state.formControls.isshippable?.value.toString() === 'true' || this.state.formControls.isshippable?.value === 1} disabled={this.state.viewOnly} onChange={(event) => this.onInputValidation(event)} />
                                            </div> */}
                                            <div className="d-flex flex-column">
                                                <Form.Check type="checkbox" id="sendinvoicecopy" className={`${this.state.formControls.sendinvoicecopy?.error ? 'error-control' : ''}`} name="sendinvoicecopy" label="Send Copy of Invoices" checked={this.state.formControls.sendinvoicecopy?.value.toString() === 'true' || this.state.formControls.sendinvoicecopy?.value === 1} disabled={this.state.viewOnly} onChange={(event) => this.onInputValidation(event)} />
                                            </div>
                                            {
                                                this.state.formControls.sendinvoicecopy?.value.toString() === 'true' || this.state.formControls.sendinvoicecopy?.value === 1 ?
                                                    <div className="float-control">
                                                        <div className="text">
                                                            {
                                                                this.state.formControls.invoiceccemail.error ? <small className="error">{this.state.formControls.invoiceccemail.error}</small> : null
                                                            }
                                                        </div>
                                                        <Form.Control type="text" id="invoice-ccemail" className={`${this.state.formControls.invoiceccemail.error ? 'error-control' : ''} ${this.state.formControls.invoiceccemail.value ? 'form-control-active' : ''}`} name="invoiceccemail" value={this.state.formControls.invoiceccemail.value} disabled={this.state.viewOnly} placeholder=" " onChange={(event) => this.onInputValidation(event)} />
                                                        <label htmlFor="invoice-ccemail">Invoice cc email</label>
                                                    </div> : null
                                            }
                                            <div className="d-flex flex-column mt-3">
                                                <label className="text-muted">Item Receipt Methods *</label>
                                            </div>
                                            <div className="d-flex">
                                                <Form.Check inline type="checkbox" checked={this.state?.ispickup?.toString() === 'true'} name="ispickup" label="Pickup" id="ispickup" onChange={(event) => this.receiptCheckBox(event)} />
                                                <Form.Check inline type="checkbox" checked={this.state?.isdelivery?.toString() === 'true'} name="isdelivery" label="Delivery" id="isdelivery" onChange={(event) => this.receiptCheckBox(event)} />
                                                <Form.Check style={{ marginRight: "0" }} inline type="checkbox" checked={this.state?.isshipping?.toString() === 'true'} name="isshipping" label="Shipping" id="isshipping" onChange={(event) => this.receiptCheckBox(event)} />
                                            </div>
                                            <div className="text">
                                                {
                                                    this.state.irmValid ? <small className="error text-danger">{'Please select an item receipt method'}</small> : null
                                                }
                                            </div>
                                            <div className="d-md-flex align-items-center mt-3">
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.formControls.locationstatecode.error ? <small className="error">{this.state.formControls.locationstatecode.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control id="locationstatecode" className={`${this.state.formControls.locationstatecode.error ? 'error-control' : ''} ${this.state.formControls.locationstatecode.value ? 'form-control-active' : ''}`} name="locationstatecode" value={this.state.formControls.locationstatecode.value} disabled={this.state.viewOnly} placeholder=" " onChange={(event) => this.onInputValidation(event)} />
                                                    <label htmlFor="locationstatecode">Location state code</label>
                                                </div>
                                                <div>
                                                    <div className="slash text-muted d-none d-md-block">&#8725;</div>
                                                    <div className="slash-or text-muted d-flex d-md-none align-items-center">
                                                        <div className='or d-flex align-items-center justify-content-center'>
                                                            <div className='or-text'>OR</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="float-control">
                                                    <div className="text">
                                                        {
                                                            this.state.formControls.locationcode.error ? <small className="error">{this.state.formControls.locationcode.error}</small> : null
                                                        }
                                                    </div>
                                                    <Form.Control id="locationcode" className={`${this.state.formControls.locationcode.error ? 'error-control' : ''} ${this.state.formControls.locationcode.value ? 'form-control-active' : ''}`} name="locationcode" value={this.state.formControls.locationcode.value} disabled={this.state.viewOnly} placeholder=" " onChange={(event) => this.onInputValidation(event)} />
                                                    <label htmlFor="locationcode">Location code</label>
                                                </div>
                                            </div>
                                            <div className='mt-3'>
                                                <label className="text-muted">ctbids.com url</label>
                                            </div>
                                            <div>
                                                {BUYER_URL}/estate-sales{this.state.formControls.locationstatecode.value ? '/' : ''}{this.state.formControls.locationstatecode.value}{this.state.formControls.locationcode.value ? '/' : ''}{this.state.formControls.locationcode.value}
                                            </div>
                                            <div style={{marginTop: '10px'}}>
                                                <div>Payment Processing Method</div>
                                                <div style={{display:'flex', marginTop:'10px'}}>
                                                    <div class="custom-control custom-switch">
                                                        <input type="checkbox" class="custom-control-input" id="paypalcommerce" checked={this.state.isautodebit} onChange={this.changeCommercePayment}/>
                                                        <label class="custom-control-label" for="paypalcommerce">PayPal Commerce Platform</label>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div style={{ marginTop: '10px' }}>
                                                <div>Training Location</div>
                                                <div style={{ display: 'flex', marginTop: '10px' }}>
                                                    <div class="custom-control custom-switch">
                                                        <input type="checkbox" class="custom-control-input" id="istestlocation" checked={this.state.istestlocation} onChange={this.changeTestLocation} />
                                                        <label class="custom-control-label" for="istestlocation">Training Location</label>
                                                    </div>
                                                </div>
                                            </div> */}
                                            <div style={{marginTop: '10px'}}>
                                                <div>Shipping Saint</div>
                                                <div style={{display:'flex', marginTop:'10px'}}>
                                                    <div class="custom-control custom-switch">
                                                        <input type="checkbox" class="custom-control-input" id="shippingsaint" checked={this.state.shippingsaint} onChange={this.changeShippingSaint}/>
                                                        <label class="custom-control-label" for="shippingsaint">Shipping Saint</label>
                                                    </div>
                                                </div>
                                            </div>

                                            { this.state.shippingsaint ? <div className="float-control">
                                                <div className="text">
                                                    {
                                                        this.state.formControls.shippingsaintaccountnumber.error ? <small className="error">{this.state.formControls.shippingsaintaccountnumber.error}</small> : null
                                                    }
                                                </div>
                                                <Form.Control type="text" id="shippingsaintaccountnumber" className={`${this.state.formControls.shippingsaintaccountnumber.error ? 'error-control' : ''} ${this.state.formControls.shippingsaintaccountnumber.value ? 'form-control-active' : ''}`} name="shippingsaintaccountnumber" value={this.state.formControls.shippingsaintaccountnumber.value} placeholder=" " onChange={(event) => this.onInputValidation(event)} />
                                                <label htmlFor="shippingsaintaccountnumber">Shipping Saint Account Number</label>
                                            </div> : '' }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <>
                                {
                                    this.state.viewOnly ?
                                        null :
                                        <div className="align-items-center justify-content-center mb-3" style={{ marginTop: "-4rem" }}>
                                            <div id="toaster" className={this.state.locationStatus.show ? "d-flex flex-row align-items-center justify-content-center toaster " : ''}>
                                                {
                                                    this.state.locationStatus.show ?
                                                        <ToasterMessage type={this.state.locationStatus.type} message={this.state.locationStatus.message} className="alert-handle"></ToasterMessage>
                                                        : this.state.stateCityError ? <small className='text-danger d-flex align-items-center justify-content-center' style={{ textAlign: 'center' }}>{this.state.stateCityError}</small> : null
                                                }
                                            </div>
                                            <div className="d-flex flex-row align-items-center justify-content-center mb-3">
                                                <Button type="button" variant="outline-dark mx-1" style={{ width: '90px' }}
                                                    onClick={this.navigateToList}>Cancel</Button>
                                                <Button type="submit" variant="secondary mx-1" style={{ width: '90px' }}
                                                    disabled={this.state.locationFormLoading || this.state.locationStatus.type === 'success' || !this.state.cityStateIsValid || this.state.irmValid }>Save {' '} {this.state.locationFormLoading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                                            </div>
                                        </div>
                                }
                            </>
                        </Form>
                }
            </div>
        );
    }
}

export default connect(state => state)(LocationEdit);
